// extracted by mini-css-extract-plugin
module.exports = {"content":"content-1pZma","banner_meal":"banner_meal-1muFL","banner_seat":"banner_seat-ZfzLW","banner_baggage":"banner_baggage-1dONw","image":"image-1QRxB"};